import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PatientDetailsSearch } from '../models/patient-details-search';
import { AddAll } from '../models/patient-search.model';
import { PatientDetails } from '../models/patient-details.model';

@Injectable({
  providedIn: 'root'
})
export class PatientDetailsService {
  private http = inject(HttpClient);

  private patientDetailsCache = new Map<number, Observable<PatientDetails>>();

  getPatientDetails(mpi: number): Observable<PatientDetails> {
    const cachedDetails = this.patientDetailsCache.get(mpi);

    if (cachedDetails) {
      return cachedDetails;
    }

    const patientDetailsSearch: PatientDetailsSearch = {
      mpi,
      addAll: AddAll.Y
    };

    const patientDetails$ = this.http
      .post<PatientDetails>(
        environment.apiUrl + '/patient/search/mpi',
        patientDetailsSearch
      )
      .pipe(
        shareReplay({
          bufferSize: 1,
          refCount: false
        })
      );

    this.patientDetailsCache.set(mpi, patientDetails$);

    return patientDetails$;
  }

  clearPatientDetailsCache(): void {
    this.patientDetailsCache.clear();
  }
}
